import locationConstants from '../constants';
import repository from 'client/repository';
import alertActions from 'areas/alert/actions';
import { receiveDivisions } from 'areas/supervisor/actions';

export function loadDivisionData() {
    return async dispatch => {
        try {

            dispatch(clear());
            const divisions = await repository.supervisor.getDivisions();
            dispatch(receiveDivisions(divisions));
        }
        catch (error) {
            dispatch(alertActions.error(error.failureReason || error.toString()));
        }
    };
}

export function locationChanged(divisionID, divisionName, projectID, projectName, siteCode, siteName, zoneCode, zoneName) {
    return {
        type: locationConstants.LOCATION_CHANGED,
        divisionID,
        divisionName,
        projectID,
        projectName, 
        siteCode, 
        siteName, 
        zoneCode, 
        zoneName
    };
}

export function divisionChanged(divisionID, divisionName) {
    return { type: locationConstants.DIVISION_CHANGED, divisionID, divisionName };
}

export function clear() {
    return { type: locationConstants.CLEAR };
}
